module.exports = __webpack_public_path__ + "static/media/close-occasion-details.ec9f1711.svg";